import { createRouter, createWebHistory } from "vue-router";

// Layouts
import AppLayout from "@/layouts/game/App.vue";
// Views
// |_ Not authenticated
import Login from "@/views/game/LoginView.vue";
import Join from "@/views/game/join/JoinView.vue";
import ConnectionProblem from "@/views/game/connectionProblem/ConnectionProblemView.vue";
import ForgotPassword from "@/views/game/connectionProblem/ForgotPasswordView.vue";
import ForgotEmail from "@/views/game/connectionProblem/forgotEmail/ForgotEmailView.vue";
import ResetPassword from "@/views/game/connectionProblem/ResetPasswordView.vue";
import Maintenance from "@/views/game/MaintenanceView.vue";
// |_ Transverse
import Instructions from "@/views/game/InstructionsView.vue";
// |_ Authenticated
import Home from "@/views/game/home/HomeView.vue";
import PreGame from "@/views/game/preGame/PreGameView.vue";
import Results from "@/views/game/ResultsView.vue";
import ResultsV2 from "@/views/game/ResultsViewV2.vue";
// Stores
import { useCandidateStore } from "@/stores/candidate.js";
import { useCloudClientStore } from "@/stores/cloud-client.js";

const gameRouter = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/login",
      name: "game-login",
      component: Login,
      meta: {
        isPublic: true,
      },
    },
    {
      path: "/join",
      name: "game-join",
      component: Join,
      meta: {
        isPublic: true,
        isTransverse: true,
      },
    },
    {
      path: "/connection-problem",
      name: "game-connection-problem",
      component: ConnectionProblem,
      meta: {
        isPublic: true,
      },
    },
    {
      path: "/connection-problem/forgot-password",
      name: "game-forgot-password",
      component: ForgotPassword,
      meta: {
        isPublic: true,
      },
    },
    /* 
    {
      path: "/connection-problem/forgot-email",
      name: "game-forgot-email",
      component: ForgotEmail,
      meta: {
        isPublic: true,
      },
    }, */
    {
      path: "/password-reset",
      name: "game-reset-password",
      component: ResetPassword,
      meta: {
        isPublic: true,
      },
    },
    {
      path: "/maintenance",
      name: "game-maintenance",
      component: Maintenance,
      meta: {
        isPublic: true,
      },
    },
    {
      path: "/instructions",
      name: "game-instructions",
      component: Instructions,
      meta: {
        isPublic: true,
        isTransverse: true,
      },
    },
    // Authenticated
    {
      path: "/",
      name: "game-home",
      component: Home,
    },
    {
      path: "/results",
      name: "game-results",
      component: Results,
    },
    {
      path: "/resultsV2",
      name: "game-results-v2",
      component: ResultsV2,
    },
    {
      path: "/pre-game",
      name: "game-waiting",
      component: PreGame,
    },
  ],
});

gameRouter.beforeEach(async (to, from, next) => {
  const { candidate, auth_token_game, getCandidate } = useCandidateStore();

  const cloudClientStore = useCloudClientStore();

  to.meta.layout = AppLayout;

  if (to.meta.isPublic) {
    if (auth_token_game) {
      if (to.meta.isTransverse) {
        return next();
      }

      await getCandidate("game-login");

      next({
        name: "game-home",
      });
    } else {
      next();
    }
  } else {
    if (!auth_token_game) {
      next({ name: "game-login" });
    } else {
      if (!candidate.candidate_id) {
        await getCandidate("game-login");
      }

      if (!cloudClientStore.canStart() && to.name === "game-waiting") {
        next({ name: "game-home" });
      }

      next();
    }
  }
});

export default gameRouter;
